import { useState } from "react";
import { createStore } from "reusable";

export const uuidHook = createStore( () => useState(""));